export class IGraphEntityRequest<K, T> {
  public get url(): string {
    const url = this.noIdPostfix ? `/${this.urlPrefix}` : `/${this.urlPrefix}/${this.id}`;

    return this.selectedFields.length > 0 ? `${url}?$select=${this.selectedFields.join(',')}` : url;
  }

  public constructor(
    public readonly mapper: (data: K) => T,
    public readonly id: string,
    public readonly urlPrefix: string,
    public readonly noIdPostfix: boolean = false,
    public readonly selectedFields: string[] = [],
  ) {}
}
